import { Step } from '../types/Step';

export const stepHasStatus = (step: Step, status: string) =>
  step.statuses && step.statuses.some((stepStatus) => stepStatus === status);
